<template>
    <div class="item-image">
        <div class="image-wrapper">
            <img :id="component_id + '_door_img'" :src="image_src" alt="" v-if="loaded" data-id="door_img">
        </div>
        <label> {{ image_side_label }} View </label>
        <div v-if="show_pending_urls_debug_box" style="max-height: 200px; overflow-y: auto;">
            <div class="flex justify-between">
                <div>
                    <input type="text" v-model="query" placeholder="Filter pending URLs" class="form-control _sm" style="width: 130px;"/>
                </div>
                <div>
                    <button @click="clearPendingUrls" class="btn-default _sm">Clear Pending URLs</button>
                </div>
            </div>
            <h3>{{ current_request_count }}/{{ max_count }} - {{ max_count > 0 ? 100 - (current_request_count / max_count * 100).toFixed(2) : 100 }}%</h3>
            <ul v-if="pendingUrlsFiltered.length > 0">
                <li v-for="url in pendingUrlsFiltered" class="cursor-pointer" :key="url.id" :class="url.status === 'success' ? 'txt-positive' : 'txt-warning'"
                    @click="copyFullUrl(url.url)">
                    <span v-if="url.status === 'error'" class="txt-danger">
                        <i class="fa fa-exclamation-triangle"></i>
                    </span>
                    <span v-if="url.isDuplicate">DUPE</span> - <span v-if="url.isReprocessed">REPROCESSED</span> - {{ url.shortUrl }} - {{ url.status }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import { Transition } from 'vue';

    export default {
        data(){
            return {
                door: null,
                image: null,
                internal_image: null,
                image_side: 'external',
                updateTo: 'external',
                loaded: false,
                lastImgController: null,
                drawfunc: null,
                component_id: 'door_image',
                current_request_count: -999999,
                pendingUrls: [],
                imageRedrawing: true,
                max_count: 0,
                query: '',
            }
        },
        computed: {
            image_src(){
                if(this.image_side === 'internal' && this.internal_image && this.updateTo === 'internal'){
                    return this.internal_image;
                }
                return this.image;
            },
            image_side_label() {
                return this.image_side === 'internal' ? 'Internal' : 'External'
            },
            pendingUrlsFiltered() {
                if (!this.query) {
                    return this.pendingUrls;
                }
                return this.pendingUrls.filter(url => url.url.includes(this.query));
            },
            show_pending_urls_debug_box() {
                return window.isBing && this.pendingUrls.length > 0;
            }
        },
        methods: {
            copyFullUrl(fullUrl) {
                navigator.clipboard.writeText(fullUrl);
            },
            clearPendingUrls() {
                window.emitter.emit('clear-pending-urls');
            },
            flipImage(){
                this.image_side = this.image_side === 'internal' ? 'external' : 'internal';

                if(this.image_side === 'internal') {
                    this.updateInternal();
                }
            },
            zoomImage() {
                const imageSrc = this.image_side === 'internal' ? this.internal_image : this.image;
                const imageLabel = this.image_side === 'internal' ? 'View from inside' : 'Viewed from outside'

                window.Swal.fire({
                    imageUrl: imageSrc,
                    imageAlt: `Viewed from ${this.image_side_label}`,
                    html: imageLabel,
                    showConfirmButton: false,
                    showCloseButton: true,
                    width: 'auto',
                    background: 'transparent',
                    customClass: {
                        popup: 'door-image-swal',
                    }
                })
            },
            updateInternal() {
                $('#' + this.component_id + '_door_img').css('opacity', 0.1);
                if (this.drawfunc === null) {
                    this.drawfunc = window._.debounce((door) => {
                        if (this.lastImgController) {
                            this.lastImgController.abort();
                        }

                        const controller = new AbortController();
                        this.lastImgController = controller;

                        window.axios.post('/api/render/door?internal', door, {
                            signal: controller.signal,
                        }).then((result) => {
                            if (this.lastImgController === controller) {
                                this.lastImgController = null;
                            }
                            this.internal_image = result.data.internal;
                            this.updateTo = 'internal';
                            $('#' + this.component_id + '_door_img').css('opacity', 1);
                        }, (failed_response) => {
                            if (failed_response?.code === 'ERR_CANCELED') {
                                return;
                            }
                            if (this.lastImgController === controller) {
                                this.lastImgController = null;
                            }
                            $('#' + this.component_id + '_door_img').css('opacity', 1);
                        });
                    }, 100);
                }
                this.drawfunc(this.door);
            },
        },
        mounted() {
            window.emitter.on('current-request-count-updated', ({ current_request_count, pendingUrls }) => {
                this.current_request_count = current_request_count;
                this.pendingUrls = pendingUrls;

                if(this.current_request_count > this.max_count) {
                    this.max_count = this.current_request_count;
                }

                if(this.current_request_count === 0) {
                    this.max_count = 0;
                }

                if(this.current_request_count > 0 || this.imageRedrawing) {
                    $('#' + this.component_id + '_door_img').css('opacity', 0.1);
                    $('#' + this.component_id + '_door_img').parent().addClass('designer_image_loading');
                } else {
                    $('#' + this.component_id + '_door_img').css('opacity', 1);
                    $('#' + this.component_id + '_door_img').parent().removeClass('designer_image_loading');
                }
            });

            window.emitter.on('img-updating', (door) => {
                this.imageRedrawing = true;
                this.door = door;
                $('#' + this.component_id + '_door_img').css('opacity', 0.1);
                $('#' + this.component_id + '_door_img').parent().addClass('designer_image_loading');
            });

            window.emitter.on('img-updated', (img) => {
                this.image = img;
                this.loaded = true;
                this.image_side = this.updateTo = 'external';
                this.imageRedrawing = false;
                $('#' + this.component_id + '_door_img').css('opacity', 1);
                $('#' + this.component_id + '_door_img').parent().removeClass('designer_image_loading');
            });

            window.emitter.on('door-updated', (door) => {
                this.door = door;
                if(this.image_side === 'internal') {
                    this.updateInternal();
                }
            });

            window.emitter.on('zoom-button-clicked', () => {
                this.zoomImage();
            });

            window.emitter.on('flip-button-clicked', (image_side) => {
                this.flipImage(image_side);
            });

        },
        onUnmounted() {
            if (this.lastImgController) {
                this.lastImgController.abort();
            }
            window.emitter.off('img-updating');
            window.emitter.off('img-updated');
            window.emitter.off('door-updated');
            window.emitter.off('zoom-button-clicked');
            window.emitter.off('flip-button-clicked');
        }
    }
</script>
